import React from "react";
import { Routes, Route } from "react-router-dom";
import PrivateRoutes from "./utils/PrivateRoutes";
import { AuthContextProvider } from "./utils/AuthContext";
import UserProfileContextProvider from "./utils/UserProfileContext";
import Oops from "./pages/Oops/Oops";
import Splash from "./pages/Splash/Splash";
import Home from "./pages/Home/Home";
import Console from "./pages/Console/Console";
import Portfolio from "./pages/Portfolio/Portfolio";
import Construction from "./pages/Oops/Construction";
import Admin from "./pages/Admin/AdminDashboard";
import "./App.css";
import Plans from "./pages/Plans/Plans";

console.log("Mvelio Debug - Admin Component is:", Admin);

function App() {
  return (
    <div className="App">
      <AuthContextProvider>
        <UserProfileContextProvider>
          <Routes>
            <Route element={<PrivateRoutes />}>
              {/* RESTRICTED ACCESS ROUTES */}
              {/* <Route path="/console" element={<Console />} /> */}
              <Route exact path="/home" element={<Home />} />
              {/* <Route path="/console" element={<Console />} /> */}
              <Route path="/admin" element={<Admin />} />
            </Route>

            {/* PUBLIC ACCESS ROUTES */}
            <Route exact path="/" element={<Construction />} />
            <Route exact path="/splash" element={<Splash />} />
            <Route exact path="/plans" element={<Plans />} />
            <Route path="/console" element={<Console />} />



            {/* DYNAMIC PORTFOLIO ROUTE */}
            {/* Placing this above /* ensures it captures any path not matched above */}
            <Route path="/:username" element={<Portfolio />} />

            {/* WILDCARD 404 */}
            <Route path="/*" element={<Oops key={Math.random()} />} />
          </Routes>
        </UserProfileContextProvider>
      </AuthContextProvider>
    </div>
  );
}

export default App;
